
import { CarouselImage,Container,Typography,CarouselSubtext } from './style';


const ImageCarousel = ({ text, subtext, image, isNarrow }) => {

    return (
             <Container>
                <CarouselImage src={image} alt="image" />
                <Typography className="carousel-text" isNarrow={isNarrow}>
                    {text}
                    {subtext && <CarouselSubtext>{subtext}</CarouselSubtext>}
                </Typography>
                    
            </Container>


    );
};

export default ImageCarousel;
